<template>
	<el-form label-position="top">
		<el-form-item label="标签对齐">
			<el-radio-group v-model="data.labelPosition">
				<el-radio-button value="left">左对齐</el-radio-button>
				<el-radio-button value="right">右对齐</el-radio-button>
				<el-radio-button value="top">顶部对齐</el-radio-button>
			</el-radio-group>
		</el-form-item>
		<el-form-item label="标签宽度">
			<el-input-number v-model.number="data.labelWidth" :min="0" />
		</el-form-item>
		<el-form-item label="组件尺寸">
			<el-radio-group v-model="data.size">
				<el-radio-button value="large">大</el-radio-button>
				<el-radio-button value="default">默认</el-radio-button>
				<el-radio-button value="small">小</el-radio-button>
			</el-radio-group>
		</el-form-item>
		<el-form-item label="表单样式">
			<el-button style="width: 100%" @click="handleSetting">设置</el-button>
		</el-form-item>
	</el-form>

	<el-dialog v-model="styleVisible" title="表单样式" center draggable :width="800">
		<ma-code-editor v-if="styleVisible" v-model="content" language="css" />
		<template #footer>
			<el-button type="primary" @click="handleSave">保存</el-button>
			<el-button @click="styleVisible = false">关闭</el-button>
		</template>
	</el-dialog>
</template>

<script lang="ts" setup>
import { PropType, ref, watch } from 'vue'
import MaCodeEditor from '@/components/ma-code-editor/index.vue'
const props = defineProps({
	config: {
		type: Object as PropType<any>,
		required: true
	}
})

const styleVisible = ref(false)
const content = ref()

const data = ref(props.config)

const handleSetting = () => {
	content.value = data.value.style
	styleVisible.value = true
}

const handleSave = () => {
	data.value.style = content.value
	styleVisible.value = false
}

const emits = defineEmits(['update:config'])
watch(data, () => emits('update:config', data))
</script>

<style lang="scss" scoped>
.el-form-item:not(:last-child) {
	border-bottom: 2px solid #eee;
	padding-bottom: 15px;
}
</style>
